import React, { useState, useEffect } from "react";
import {
  FaUpload,
  FaCheckCircle,
  FaFileExcel,
  FaInfoCircle,
} from "react-icons/fa";
import axios from "axios";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import "../../css/CarguePlantilla.css";

function CarguePlantilla() {
  const cookies = new Cookies();
  const [archivo, setArchivo] = useState(null);
  const [usuario, setUsuario] = useState("");
  const [cargando, setCargando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [progreso, setProgreso] = useState("");
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    setUsuario(cookies.get("nombreUsuario") || "");
  }, []);

  const handleArchivo = (e) => setArchivo(e.target.files[0]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setResultado(null);

    if (!archivo) {
      return Swal.fire(
        "Archivo no seleccionado",
        "Selecciona un archivo Excel.",
        "warning"
      );
    }

    if (!archivo.name.toLowerCase().endsWith(".xlsx")) {
      return Swal.fire("Formato inválido", "El archivo debe ser .xlsx", "info");
    }

    setProgreso("⏳ Validando archivo seleccionado...");
    setCargando(true); // ya lo tienes

    const formData = new FormData();
    formData.append("archivo", archivo);
    formData.append("usuario", usuario);

    try {
      setProgreso("📄 Validando formato del Excel...");
      await new Promise((r) => setTimeout(r, 500)); // Simula tiempo de validación

      setProgreso("🧩 Validando columnas requeridas...");
      await new Promise((r) => setTimeout(r, 500));

      setProgreso("📥 Procesando archivo...");

      const response = await axios.post(
        `${baseURL}/api/CargueArchivo/CargarProcesarExcel`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      setResultado({
        mensaje: response.data.mensaje,
        totalInsertados: response.data.totalInsertados,
        rutaDescarga: response.data.rutaDescarga || "",
      });

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Carga finalizada con éxito",
        showConfirmButton: false,
        timer: 3000,
      });
      setProgreso("✅ Proceso completado con éxito.");
    } catch (error) {
      console.error("Error:", error);
      Swal.fire(
        "Error",
        error.response?.data?.mensaje || "Error inesperado",
        "error"
      );
      setProgreso("❌ Error al procesar el archivo.");
    } finally {
      setCargando(false);
      setTimeout(() => setProgreso(""), 2000);
    }
  };

  const handleDescargarResultado = async () => {
    if (!resultado?.rutaDescarga) return;

    const nombreArchivo = resultado.rutaDescarga.split("/").pop();

    try {
      const archivoResponse = await axios.get(
        `${baseURL}/api/Reportes/DescargarReporte?nombreArchivo=${nombreArchivo}&carpeta=ResultadosCargue`,
        { responseType: "blob" }
      );

      const url = window.URL.createObjectURL(new Blob([archivoResponse.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nombreArchivo);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      Swal.fire("Error", "No se pudo descargar el archivo", "error");
      console.error(error);
    }
  };

  return (
    <div className="container-fluid mt-4">
      <div className="row">
        {/* Panel de Instrucciones con Callout */}
        <div className="col-md-6">
          <div className="callout callout-info navy">
            <h5 className="titulo">
              <FaInfoCircle className="mr-2" /> Instrucciones
            </h5>
            📥 Descarga la{" "}
            <a href="/archivos/PlantillaCargue.xlsx" download>
              plantilla base aquí
            </a>
            <br />
            🛑 No cambies los encabezados ni el orden.
            <br />
            ✅ Completa todos los campos requeridos.
            <br />
            💾 Guarda en formato <strong>.xlsx</strong>.<br />
            📤 Usa el panel derecho para cargar el archivo.
            <br />
            <br />
          </div>
        </div>

        {/* Panel de Carga con Card */}
        {/* Panel de Carga con Callout */}
        <div className="col-md-6">
          <div className="callout callout-success sin-linea">
            <h5 className="titulo">
              <FaFileExcel className="mr-2" /> Cargar Plantilla Excel
            </h5>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="archivo">Archivo Excel (.xlsx)</label>
                <div className="custom-file">
                  <input
                    type="file"
                    className="custom-file-input"
                    id="archivo"
                    accept=".xlsx"
                    onChange={handleArchivo}
                    disabled={cargando}
                  />
                  <label className="custom-file-label" htmlFor="archivo">
                    {archivo ? archivo.name : "Seleccionar archivo"}
                  </label>
                </div>
              </div>

              <button
                type="submit"
                className="btn navy btn-block mt-3"
                disabled={cargando}
                style={{ marginBottom: "20px" }}
              >
                {cargando ? "Procesando..." : "Subir Archivo"}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Progreso */}
      {progreso && (
        <div className="row mt-3">
          <div className="col-md-12">
            <div className="alert alert-secondary mb-0">
              <strong>{progreso}</strong>
            </div>
          </div>
        </div>
      )}

      {/* Resultado */}
      {resultado && (
        <div className="row mt-3">
          <div className="col-md-12">
            <div className="callout callout-info navy">
              <h5 className="mb-3 titulo">
                <FaCheckCircle className="mr-2" />
                Resultado del Cargue
              </h5>
              <strong>📝 Mensaje:</strong> {resultado.mensaje}
              <br />
              <strong>📦 Total insertados:</strong> {resultado.totalInsertados}
              {resultado.rutaDescarga && (
                <p>
                  📄{" "}
                  <button
                    onClick={handleDescargarResultado}
                    className="btn btn-link text-dark font-weight-bold p-0"
                  >
                    Descargar archivo de resultado
                  </button>
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CarguePlantilla;
